export const ADD_INPUT_MODAL = Symbol('ADD_INPUT')
